"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var partition_1 = __importDefault(require("../partition"));
var metrics_utils_1 = require("@snapchat/metrics-utils");
var computeMetricKey_1 = __importDefault(require("@snapchat/metrics-utils/lib/utils/computeMetricKey"));
var reservoirSample_1 = __importDefault(require("@snapchat/metrics-utils/lib/utils/reservoirSample"));
var metrics_web_1 = __importDefault(require("../proto/metrics_web"));
var WebMetricCollector = (function (_super) {
    __extends(WebMetricCollector, _super);
    function WebMetricCollector(options) {
        var _this = _super.call(this) || this;
        if (!options.partitionName || !partition_1["default"][options.partitionName.toUpperCase()]) {
            throw new Error('Partition is not defined!');
        }
        _this.partitionName = options.partitionName;
        _this.flavor = options.flavor;
        _this.variant = options.variant;
        _this.versionNumber = options.versionNumber;
        _this.maxSizePerMetric = options.maxSizePerMetric || 50;
        _this.defaultDimensions = options.defaultDimensions;
        return _this;
    }
    WebMetricCollector.prototype.increment = function (_a) {
        var metricsName = _a.metricsName, dimensions = _a.dimensions, value = _a.value;
        var metricKey = computeMetricKey_1["default"]({ metricsName: metricsName, dimensions: dimensions });
        var prevMetricObject = this.metrics.counters[metricKey];
        this.metrics.counters[metricKey] = this.updateMetricObject({
            prevMetricObject: prevMetricObject,
            metricsName: metricsName,
            dimensions: this._decorateDimensions(dimensions),
            value: value,
            shouldAggregate: true
        });
    };
    WebMetricCollector.prototype.addHistogram = function (_a) {
        var metricsName = _a.metricsName, dimensions = _a.dimensions, value = _a.value;
        var metricKey = computeMetricKey_1["default"]({ metricsName: metricsName, dimensions: dimensions });
        var prevMetricObject = this.metrics.levels[metricKey];
        this.metrics.levels[metricKey] = this.updateMetricObject({
            prevMetricObject: prevMetricObject,
            metricsName: metricsName,
            dimensions: this._decorateDimensions(dimensions),
            value: value,
            shouldAggregate: false
        });
    };
    WebMetricCollector.prototype.addTimer = function (_a) {
        var metricsName = _a.metricsName, dimensions = _a.dimensions, milliSec = _a.milliSec;
        var metricKey = computeMetricKey_1["default"]({ metricsName: metricsName, dimensions: dimensions });
        var prevMetricObject = this.metrics.timers[metricKey];
        this.metrics.timers[metricKey] = this.updateMetricObject({
            prevMetricObject: prevMetricObject,
            metricsName: metricsName,
            dimensions: this._decorateDimensions(dimensions),
            value: milliSec,
            shouldAggregate: false
        });
    };
    WebMetricCollector.prototype.getPayload = function () {
        var frame = this.convertToMetricFrame(this.metrics);
        return metrics_web_1["default"].MetricFrame.encode(frame).finish();
    };
    WebMetricCollector.prototype.updateMetricObject = function (_a) {
        var prevMetricObject = _a.prevMetricObject, metricsName = _a.metricsName, _b = _a.dimensions, dimensions = _b === void 0 ? {} : _b, value = _a.value, _c = _a.shouldAggregate, shouldAggregate = _c === void 0 ? false : _c;
        var metricObject = prevMetricObject;
        if (!metricObject) {
            metricObject = new metrics_web_1["default"].Metric({
                partitionName: this.partitionName,
                metricName: metricsName,
                customDimensions: dimensions
            });
        }
        if (shouldAggregate) {
            var existingValueList = metricObject.values;
            var newValue = value + (Number(existingValueList[0]) || 0);
            metricObject.values = [newValue];
        }
        else {
            metricObject.values.push(value);
        }
        return metricObject;
    };
    WebMetricCollector.prototype.convertToMetricFrame = function (metricsToConvert) {
        var _this = this;
        var frame = new metrics_web_1["default"].MetricFrame();
        frame.clientOsType = metrics_web_1["default"].OsType.OS_WEB;
        if (this.flavor || this.variant || this.versionNumber) {
            var appVersion = new metrics_web_1["default"].AppVersion();
            if (this.flavor) {
                appVersion.flavor = this.flavor;
            }
            if (this.variant) {
                appVersion.variant = this.variant;
            }
            if (this.versionNumber) {
                appVersion.versionNumber = this.versionNumber;
            }
            frame.appVersion = appVersion;
        }
        Object.keys(metricsToConvert.counters).forEach(function (key) {
            var metric = metricsToConvert.counters[key];
            frame.counters.push(metric);
        });
        Object.keys(metricsToConvert.timers).forEach(function (key) {
            var metric = _this.sampleMetricValues(metricsToConvert.timers[key]);
            frame.timers.push(metric);
        });
        Object.keys(metricsToConvert.levels).forEach(function (key) {
            var metric = _this.sampleMetricValues(metricsToConvert.levels[key]);
            frame.levels.push(metric);
        });
        return frame;
    };
    WebMetricCollector.prototype.sampleMetricValues = function (metricObject) {
        metricObject.values = reservoirSample_1["default"](metricObject.values, this.maxSizePerMetric);
        return metricObject;
    };
    WebMetricCollector.prototype._decorateDimensions = function (dimensions) {
        if (!this.defaultDimensions) {
            return dimensions;
        }
        return __assign(__assign({}, this.defaultDimensions), (dimensions || {}));
    };
    return WebMetricCollector;
}(metrics_utils_1.MetricCollector));
exports["default"] = WebMetricCollector;
//# sourceMappingURL=WebMetricCollector.js.map